module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.is_manager) ? _c('div', [_c('div', {
    staticClass: "edit-document-button",
    class: _vm.scroll.headerFixed ? 'fix-button-top' : ''
  }, [_c('el-button', {
    staticClass: "circle-button",
    attrs: {
      "type": "success",
      "icon": "el-icon-check",
      "title": "保存"
    },
    on: {
      "click": _vm.addContent
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "document-title"
  }, [_c('el-row', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTitle),
      expression: "currentTitle"
    }],
    staticClass: "documentTitle",
    staticStyle: {
      "outline": "none"
    },
    attrs: {
      "placeholder": "标题"
    },
    domProps: {
      "value": (_vm.currentTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentTitle = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "toolbar",
    attrs: {
      "id": "toolbar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    ref: "content",
    staticClass: "editor",
    attrs: {
      "id": "editor"
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b7beaf6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/editorItem.vue
// module id = 641
// module chunks = 1